// @flow
import CheckboxField from './CheckboxField';
export default CheckboxField;
